import { apiGet } from 'api';
import { DfiReportResponse } from 'types';

export const getDfiAnnualReport = (reportYear: number): Promise<DfiReportResponse> =>
  apiGet<DfiReportResponse>(`reports/dfiAnnual/${reportYear}`);
